<template>
  <section class="premium-section" :class="{ 'is-active': isActive }">
    <!-- 회전 워터마크 -->
    <div class="rotating-watermark">
      <svg viewBox="0 0 4000 4000">
        <defs>
          <path id="circleText" d="M2000,2000 m-1700,0 a1700,1700 0 1,1 3400,0 a1700,1700 0 1,1 -3400,0" fill="none"/>
        </defs>
        <text>
          <textPath href="#circleText" startOffset="0%">PREMIUM  PREMIUM  PREMIUM  PREMIUM</textPath>
        </text>
      </svg>
    </div>

    <!-- 3패널 슬라이드 컨테이너 -->
    <div class="panels-track" :class="{ 'step-1': step === 1 }">

      <!-- 패널1: 왼쪽 이미지 -->
      <div class="panel panel-image">
        <div class="left-image anim" :class="{ show: isActive }" style="--delay: 0.3s">
          <img :src="bgImg" alt="" />
          <div class="image-overlay"></div>
        </div>
        <div class="left-title">
          <div class="title-wrap anim" :class="{ show: isActive }" style="--delay: 0.5s">
            <h2 class="premium-text">PREMIUM</h2>
            <span class="script-text">Special Premium Living</span>
          </div>
        </div>
      </div>

      <!-- 패널2: 프리미엄 5개 특장점 (이미지 + 설명) -->
      <div class="panel panel-features">
        <div class="features-inner">
          <!-- 상단 헤더 -->
          <div class="features-header anim" :class="{ show: isActive }" style="--delay: 0.3s">
            <span class="header-label">Premium Value</span>
            <div class="header-gold-line"></div>
          </div>

          <!-- 세로 리스트 (이미지 + 설명) -->
          <div class="feature-list">
            <div
              v-for="(item, idx) in features"
              :key="idx"
              class="feature-row anim"
              :class="{ show: isActive }"
              :style="{ '--delay': (0.5 + idx * 0.1) + 's' }"
            >
              <div class="feature-img">
                <img :src="item.image" :alt="item.title" />
              </div>
              <div class="feature-body">
                <span class="feature-num">{{ String(idx + 1).padStart(2, '0') }}</span>
                <h4 class="feature-title">{{ item.title }}</h4>
                <div class="feature-bar"></div>
                <p class="feature-desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 패널3: 이미지 + 1x6 리스트 -->
      <div class="panel panel-detail">
        <div class="detail-content">
          <div class="detail-image anim" :class="{ show: step === 1 }" style="--delay: 0.2s">
            <img :src="premiumImg" alt="단지설계" />
          </div>
          <div class="detail-grid">
            <div
              v-for="(item, idx) in detailFeatures"
              :key="idx"
              class="detail-item anim"
              :class="{ show: step === 1 }"
              :style="{ '--delay': (0.3 + idx * 0.08) + 's' }"
            >
              <span class="detail-item-num">{{ String(idx + 1).padStart(2, '0') }}</span>
              <div class="detail-item-body">
                <span class="detail-item-title">{{ item.title }}</span>
                <span class="detail-item-desc">{{ item.desc }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import bgImg from '@/assets/hero/hero2.jpg'
import premiumImg from '@/assets/sub02_01.jpg'
import feature1 from '@/assets/section/직주근접.jpg'
import feature2 from '@/assets/section/출퇴근.jpg'
import feature3 from '@/assets/section/확장.png'
import feature4 from '@/assets/section/대단지.jpg'
import feature5 from '@/assets/section/주거환경.png'

export default {
  name: 'PremiumSection',
  props: {
    isActive: { type: Boolean, default: false }
  },
  data() {
    return {
      bgImg,
      premiumImg,
      step: 0,
      features: [
        { image: feature1, title: '직주근접 친환경 주거타운', desc: '김천생활권과 구미 산업권을 동시에 누리고 금오산 자락의 친환경 중심의 주거타운' },
        { image: feature2, title: '김천·구미를 빠르게 잇는 출퇴근 동선', desc: '김천구미역(KTX, SRT) 이용 가능한 광역철도 / 김천JC, 북구미IC 접근 용이' },
        { image: feature3, title: '김천구미 新 주거단지', desc: '송천, 부곡, 봉곡, 국사지구의 김천 주거확장의 중심 축' },
        { image: feature4, title: '지역 內 736세대 대단지 아파트', desc: '체계적인 단지 배치와 관리가 가능한 스케일 / 브랜드 아파트 기준에 맞춘 단지구성' },
        { image: feature5, title: '실거주자가 직접 선택하는 주거환경', desc: '실거주 기준으로 계획된 합리적 주거비용 / 조합원이 참여하는 구조' }
      ],
      detailFeatures: [
        { title: '광역 교통망', desc: '경부고속도로 동김천IC·북구미IC 접근 우수, 85번 국도로 김천·구미 시내 빠르게 이동' },
        { title: '더블 생활권', desc: '김천·구미 시내의 마트, 병원, 상업시설 등 다양한 생활 인프라를 함께 이용 가능' },
        { title: '금오산 자연환경', desc: '금오산 국사봉·제석봉이 가까워 자연 조망과 생활소음이 적은 프라이버시 강화 입지' },
        { title: '교육환경', desc: '아포초·아포중·경북과학기술고 반경 1.2km 이내 위치, 도보 등하교 가능' },
        { title: '미래가치', desc: '일반국도 85호선 도로 연장 개통 예정으로 교통 접근성 및 미래가치 상승' },
        { title: '실용적 주거입지', desc: '자연과 함께하는 실용적 주거환경, 김천·구미 두 도시의 생활 인프라를 영위' }
      ]
    }
  },
  methods: {
    canScrollDown() {
      return this.step < 1
    },
    canScrollUp() {
      return this.step > 0
    },
    scrollDown() {
      if (this.step < 1) {
        this.step++
        return true
      }
      return false
    },
    scrollUp() {
      if (this.step > 0) {
        this.step--
        return true
      }
      return false
    },
    resetStep() {
      this.step = 0
    }
  }
}
</script>

<style scoped>
.premium-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

/* ===== 애니메이션 ===== */
.anim {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: var(--delay, 0s);
}

.anim.show {
  opacity: 1;
  transform: translateY(0);
}

/* ===== 회전 워터마크 ===== */
.rotating-watermark {
  position: absolute;
  right: -1700px;
  top: 50%;
  transform: translateY(-50%);
  width: 2200px;
  height: 2200px;
  z-index: 1;
  animation: spin 40s linear infinite;
  pointer-events: none;
}

.rotating-watermark svg { width: 100%; height: 100%; }

.rotating-watermark text {
  font-family: var(--font-pretendard);
  font-size: 500px;
  font-weight: 800;
  fill: rgba(0, 0, 0, 0.03);
  letter-spacing: 12px;
  text-transform: uppercase;
}

@keyframes spin {
  to { transform: translateY(-50%) rotate(360deg); }
}

/* ===== 3패널 슬라이드 트랙 ===== */
.panels-track {
  display: flex;
  width: 150%;
  height: 100%;
  transition: transform 1.2s cubic-bezier(0.65, 0, 0.35, 1);
}

.panels-track.step-1 {
  transform: translateX(-33.333%);
}

.panel {
  width: 33.333%;
  height: 100%;
  flex-shrink: 0;
  position: relative;
}

/* ===== 패널1: 이미지 ===== */
.panel-image {
  background: #080c14;
}

.left-image {
  position: absolute;
  inset: 0;
}

.left-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(8, 12, 20, 0.85) 0%,
    rgba(8, 12, 20, 0.15) 50%,
    transparent 100%
  );
}

.left-title {
  position: absolute;
  bottom: 8%;
  left: 10%;
  z-index: 10;
}

.title-wrap { position: relative; }

.premium-text {
  font-family: var(--font-pretendard);
  font-size: clamp(56px, 5vw, 84px);
  font-weight: 900;
  color: #fff;
  letter-spacing: 4px;
  margin: 0;
  line-height: 1;
}

.script-text {
  position: absolute;
  left: 55%;
  bottom: -30%;
  font-family: var(--font-script);
  font-size: clamp(32px, 3vw, 50px);
  color: #c9a96e;
  white-space: nowrap;
}

/* ===== 패널2: 특장점 ===== */
.panel-features {
  background: #f8f7f4;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.features-inner {
  width: 100%;
  max-width: 720px;
  padding: 0 40px;
  max-height: 100vh;
  overflow-y: auto;
  scrollbar-width: none;
}

.features-inner::-webkit-scrollbar {
  display: none;
}

/* 헤더 */
.features-header {
  margin-bottom: 18px;
  text-align: center;
  padding-top: 20px;
}

.header-label {
  font-family: var(--font-script);
  font-size: 52px;
  color: var(--ecofore-accent);
  line-height: 1.2;
}

.header-gold-line {
  width: 40px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--ecofore-accent), transparent);
  margin: 16px auto 0;
}

/* 세로 리스트 (이미지 + 설명) */
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 24px;
}

.feature-row {
  display: flex;
  align-items: stretch;
  gap: 16px;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-row:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.08);
}

.feature-img {
  flex: 0 0 140px;
  overflow: hidden;
  border-radius: 5px;
  aspect-ratio: 16 / 10;
}

.feature-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.feature-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px 6px;
}

.feature-num {
  font-family: var(--font-paperlogy);
  font-size: 13px;
  font-weight: 700;
  color: var(--ecofore-accent);
  letter-spacing: 1px;
  margin-bottom: 5px;
}

.feature-title {
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
  line-height: 1.3;
}

.feature-bar {
  width: 20px;
  height: 1px;
  background: var(--ecofore-accent);
  margin-bottom: 6px;
  opacity: 0.5;
}

.feature-desc {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 400;
  color: #666;
  margin: 0;
  line-height: 1.5;
  word-break: keep-all;
}

/* ===== 패널3: 단지설계 상세 ===== */
.panel-detail {
  background: #f8f7f4;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  overflow: hidden;
}

.detail-content {
  width: 100%;
  max-width: 720px;
  max-height: 100vh;
  overflow-y: auto;
  scrollbar-width: none;
}

.detail-content::-webkit-scrollbar {
  display: none;
}

.detail-image {
  width: 100%;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 8px;
}

.detail-image img {
  width: 100%;
  height: auto;
  display: block;
}

.detail-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.detail-item {
  padding: 18px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.detail-item:last-child {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.detail-item-num {
  flex: 0 0 auto;
  font-family: var(--font-paperlogy);
  font-size: 16px;
  font-weight: 700;
  color: var(--ecofore-accent);
  letter-spacing: 1px;
  min-width: 36px;
  padding-top: 2px;
}

.detail-item-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-item-title {
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.3px;
}

.detail-item-desc {
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 400;
  color: #555;
  line-height: 1.5;
}

/* ===== 반응형 ===== */

/* 1200px: 약간 축소 */
@media (max-width: 1200px) {
  .features-inner { max-width: 640px; padding: 0 32px; }
  .feature-img { flex-basis: 160px; }
  .feature-title { font-size: 15px; }
  .detail-title { font-size: 24px; }
  .panel-detail { padding: 30px 28px; }
}

/* 1024px (태블릿): 세로 스택, 2열 유지 */
@media (max-width: 1024px) {
  .rotating-watermark {
    right: -1200px;
    width: 1600px;
    height: 1600px;
  }

  .rotating-watermark text {
    font-size: 380px;
  }

  .panels-track {
    flex-direction: column;
    width: 100%;
    height: 200%;
  }

  .panels-track.step-1 {
    transform: translateY(-50%);
  }

  .panel {
    width: 100%;
    height: 50%;
  }

  .panel-image {
    display: none;
  }

  .features-inner {
    max-width: 640px;
    padding: 0 32px;
  }

  .header-label {
    font-size: 44px;
  }

  .feature-img {
    flex-basis: 150px;
  }

  .feature-title {
    font-size: 15px;
  }

  .panel-detail {
    padding: 32px 32px;
  }

  .detail-content {
    max-width: 480px;
  }

  .detail-label {
    font-size: 36px;
  }

  .detail-title {
    font-size: 24px;
  }

  .detail-desc {
    font-size: 12px;
  }

  .detail-item {
    padding: 14px 0;
    gap: 14px;
  }

  /* 태블릿에서 애니메이션 거리 축소 */
  .anim {
    transform: translateY(20px);
  }
}

/* 768px (모바일): 1열 카드, 전체 축소 */
@media (max-width: 768px) {
  .rotating-watermark {
    right: -900px;
    width: 1100px;
    height: 1100px;
  }

  .rotating-watermark text {
    font-size: 280px;
  }

  .panels-track {
    flex-direction: column;
    width: 100%;
    height: 200%;
  }

  .panels-track.step-1 {
    transform: translateY(-50%);
  }

  .panel {
    width: 100%;
    height: 50%;
  }

  .panel-image {
    display: none;
  }

  /* 패널 내부 스크롤 허용 */
  .panel-features,
  .panel-detail {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* 패널2: 특장점 — 세로 중앙 정렬 */
  .panel-features {
    align-items: center;
    justify-content: center;
    padding: 24px 0;
  }

  .features-inner {
    max-width: 100%;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .features-header {
    margin-bottom: 20px;
  }

  .header-label {
    font-size: 36px;
  }

  .header-gold-line {
    width: 32px;
    margin-top: 10px;
  }

  .feature-list {
    gap: 14px;
    padding-bottom: 24px;
  }

  .feature-row {
    padding: 12px;
    gap: 14px;
  }

  .feature-img {
    flex: 0 0 120px;
  }

  .feature-title {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .feature-bar {
    width: 18px;
    margin-bottom: 6px;
  }

  .feature-desc {
    font-size: 12px;
    line-height: 1.5;
  }

  .feature-num {
    font-size: 12px;
    margin-bottom: 4px;
  }

  /* 패널3: 단지설계 상세 — 세로 중앙 */
  .panel-detail {
    padding: 24px 20px;
    align-items: center;
    justify-content: center;
  }

  .detail-content {
    max-width: 100%;
  }

  .detail-header {
    margin-bottom: 14px;
  }

  .detail-label {
    font-size: 26px;
  }

  .detail-gold-line {
    width: 32px;
    margin: 10px auto;
  }

  .detail-sub {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.65);
  }

  .detail-title {
    font-size: 22px;
    margin-bottom: 6px;
    color: #1a1a1a;
  }

  .detail-desc {
    font-size: 14px;
    line-height: 1.6;
    color: #555;
  }

  .detail-desc br {
    display: none;
  }

  .detail-image {
    margin-bottom: 14px;
  }


  .detail-item-num {
    font-size: 14px;
    min-width: 30px;
  }

  .detail-item {
    padding: 10px 0;
  }

  .detail-item-title {
    font-size: 14px;
    color: #1a1a1a;
  }

  .detail-item-desc {
    font-size: 12px;
    color: #555;
  }

  /* 모바일 애니메이션: 이동거리 축소 */
  .anim {
    transform: translateY(16px);
    transition-duration: 0.7s;
  }
}

/* 480px (소형 모바일): 추가 축소 */
@media (max-width: 480px) {
  .panel-features {
    padding: 20px 0;
  }

  .features-inner {
    padding: 0 18px;
  }

  .header-label {
    font-size: 30px;
  }

  .features-header {
    margin-bottom: 16px;
  }

  .feature-row {
    padding: 10px;
    gap: 12px;
  }

  .feature-img {
    flex: 0 0 100px;
  }

  .feature-title {
    font-size: 13px;
  }

  .feature-desc {
    font-size: 11px;
  }

  .panel-detail {
    padding: 20px 16px;
  }

  .detail-label {
    font-size: 22px;
  }

  .detail-title {
    font-size: 20px;
  }

  .detail-sub {
    font-size: 14px;
  }

  .detail-desc {
    font-size: 13px;
  }


  .detail-item-title {
    font-size: 13px;
  }

  .detail-item-desc {
    font-size: 11px;
  }

  .anim {
    transform: translateY(12px);
    transition-duration: 0.6s;
  }
}
</style>
